/**
 * Header builder for every /api/messages/* and /api/calls/* request.
 * Passes two SCOPING headers:
 *   • X-Active-Venue-App-Id — locks the actor id to a venue for owners
 *   • X-Active-Role         — locks the query filter to the acting role
 *                             so a user with host+guest roles doesn't see
 *                             one inbox leak into the other
 * See backend `messaging_conversations.resolve_active_role`.
 */
export const buildMessageHeaders = (token, activeVenueAppId, activeRole) => {
  const headers = { Authorization: `Bearer ${token}` };

  if (activeVenueAppId) {
    headers['X-Active-Venue-App-Id'] = activeVenueAppId;
  }
  if (activeRole) {
    headers['X-Active-Role'] = activeRole;
  }

  return headers;
};
